import {useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import MainLayout from '../layouts/main';
import RegisterContent from './content';
import {AUTHENTICATED} from '../../redux/constants';

function RegisterPage() {
  const isAuthenticated = useSelector(state => state.auth.status === AUTHENTICATED);
  if (isAuthenticated) return (<Redirect to='/report'/>);

  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      <RegisterContent/>
    </MainLayout>
  );
}

export default RegisterPage;
